import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    padding: `${theme.spacing.space20}px ${theme.spacing.space16}px`,
    background: "#610000",
    borderRadius: theme.radius.small,
  },
  wallets: {
    justifyContent: "initial",
    marginTop: theme.spacing.space12,
  },
}));
